import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import { Profile } from '../../../core/models/profile.model';
import { User } from '../../../core/models/user.model';
import { Review } from '../../../core/models/review.model';
import { AuthService } from '../../../core/services/auth.service';
import { ProfileService } from '../../../core/services/profile.service';
import { ApiService } from '../../../core/services/api.service';
import { DesignService } from '../../../core/services/design.service';
import { LoaderService } from '../../../core/loader.service';
import { UserService } from '../../../core/services/user.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ReportBugFeedbackDTO } from '../../../core/models/reportBugFeedback.modal';
import { PollDTO } from '../../../core/models/poll.modal';
import { ChangeDetectorRef } from '@angular/core';

declare var $: any;
declare var CKSource: any;

@Component({
  selector: 'app-post-review-model',
  templateUrl: './post-review-model.component.html',
  styleUrls: ['./post-review-model.component.scss'],
})
export class PostReviewModelComponent implements OnInit {
  @Output() reviewCreated = new EventEmitter<{ ProfileID: number }>();

  user: User = new User();
  profile: Profile = new Profile();
  review = new Review();
  errMsg: string = '';
  mentioned: boolean = false;
  public reviewImageCollection: any[] = [];
  public reviewImageCollectionUpload: File[] = [];
  defaultProfile = new Profile();
  isModalOpening: boolean = false;
  pollEditorInitialized: boolean = false;
  isFromReminder: boolean = false;
  searchValueForPost = '';
  searchSuggetionListForPost: string[] = [];
  totalMediaSize: number = 0;
  // mediaOverflow: boolean;
  mediaTypeInvalid: boolean = false;
  imageExceed: boolean = false; // TO show error when image size exceeded than limit.
  viewMoreMedia = [];
  viewMoreMediaId = null;
  maxFiles: boolean = false;
  reviewContentValidation: boolean = false;
  profileTagValidation: boolean = false;
  profileList = new Array<Profile>();
  itemSelectedFleg: boolean = false; // If angular mention is clicked or not
  // Angular Mentions
  // initialized mentionConfig object used for configuration of @ngular mentions dropdown.
  items: any[] = [];
  verified: boolean = false;
  username: string = '';
  loader: boolean = false;
  contentInvalid: boolean = false;
  thumbnailData: string[] = [];
  clickEventsubscription: Subscription;
  verbShowing: any;
  headerStyle: string;
  headerStyleSubscription: any;
  imgloading: boolean = false;
  allMensionList: any[] = [];
  postOnOwnProfile: boolean = false;
  postOnblockProfile: boolean = false;
  textContentValid = false;
  disable = false;
  blockAndBlockedByProfileList: string[] = [];
  textContentLength = false;
  reportBugFeedbackDTO: ReportBugFeedbackDTO = new ReportBugFeedbackDTO();
  reviewType: string = 'chat';
  daysArray: number[] = Array.from({ length: 60 }, (_, i) => i + 1);

  maxOptions: number = 2;
  pollDays: string | number = 3;
  userToMention: string = '';
  ckeditorInitialized = false;
  isEditSuccess: boolean = false;
  isEditUrl: boolean = false;
  editorLoading: boolean = false;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private profileService: ProfileService,
    private designService: DesignService,
    private loaderService: LoaderService,
    private userService: UserService,
    private router: Router,
    private location: Location,
    private cdr: ChangeDetectorRef
  ) {
    this.daysArray = Array.from({ length: 60 }, (_, i) => i + 1);
    this.clickEventsubscription = this.designService
      .getClickEvent()
      .subscribe((data) => {
        this.user = this.authService.getUser();
        this.verbShowing = this.calculateVerbDate(this.user.verbShowingDate); // use for show msg periodically
        if (data === 'polling' || (data && data.type === 'edit-poll')) {
          this.reviewType = 'polling';
          if (data && data.type === 'edit-poll') {
            this.isEditUrl = true;
            this.review = JSON.parse(JSON.stringify(data.poll));
            // Ensure pollDTO is properly mapped if it comes as a flat structure or nested
            if (!this.review.pollDTO && data.poll.pollDTO) {
              this.review.pollDTO = JSON.parse(
                JSON.stringify(data.poll.pollDTO)
              );
            }
            if (this.review.pollDTO) {
              this.review.pollDTO.pollDurationInDays = Number(
                this.review.pollDTO.pollDurationInDays
              );
            }
          } else {
            this.isEditUrl = window.location.href.includes('edit=true');
            this.review = new Review();
            this.review.reviewType = 'polling';
            this.review.pollDTO = new PollDTO();
          }

          if (!this.isModalOpening) {
            this.isModalOpening = true;
            // this.openModal();
            setTimeout(() => {
              this.openModal();
            }, 300);
          }
        } else if (data && data.type === 'edit-chat') {
          this.reviewType = 'chat';
          this.isEditUrl = true;
          this.review = JSON.parse(JSON.stringify(data.review));
          delete this.review.pollDTO;

          if (!this.isModalOpening) {
            this.isModalOpening = true;
            // this.openModal();
            setTimeout(() => {
              this.openModal();
            }, 300);
          }
        }
      });

    // diditpage
    this.headerStyle = designService.headerStyle;
    this.headerStyleSubscription =
      this.designService.headerStyleChange.subscribe((value) => {
        this.headerStyle = value;
        if (this.headerStyle == 'profile' && this.user !== null) {
          this.verbShowing = this.calculateVerbDate(this.user.verbShowingDate); // use for show msg periodically
        }
      });
  }

  ngOnInit() {
    this.user = this.authService.getUser();
    var user = this.authService.getUser();
    if (user != null || this.authService.getLogflag()) {
      this.defaultProfile.profileName = user.defaultProfileName;
      this.defaultProfile.profileImage = user.defaultProfileImage;
      this.defaultProfile.tagName = user.defaultProfileTagName;
      this.defaultProfile.id = user.defaultProfileId;
      this.verified = user.verified;
      if (this.user.verbShowingDate == null) {
        this.verbShowing = true;
      } else {
        this.verbShowing = this.calculateVerbDate(this.user.verbShowingDate); // use for show msg periodically
      }
    }
    // this.ckeditor(document.querySelector('#content'));

    // $('#postReviewModel').on('shown.bs.modal', () => {
    //   if (!this.ckeditorInitialized) {
    //     const el = document.querySelector('#content');
    //     if (el) {
    //       this.ckeditor(el);
    //       this.ckeditorInitialized = true;
    //     }
    //   }
    // });

    // $('#postReviewModel').on('hidden.bs.modal', () => {
    //   this.ckeditorInitialized = false; // reset for next open
    // });
    if (this.user != null && this.user.defaultProfileId != null) {
      this.getBlockProfileDetails();
    }
    this.isEditUrl = window.location.href.includes('edit=true');
    $('#postReviewModel').on('hidden.bs.modal', () => {
      if (!this.isFromReminder) {
        this.closePopup(undefined, undefined, this.isEditSuccess);
      }
    });
  }

  // ngAfterViewInit(): void {
  //   setTimeout(() => {
  //     this.review.pollDTO = new PollDTO();
  //     this.review.pollDTO.pollDurationInDays = 3;
  //   });
  // }
  calculateVerbDate(dateSent: any) {
    dateSent = new Date(dateSent);
    let result = false;
    if (!!dateSent) {
      var date1 = formatDate(new Date(), 'yyyy-MM-dd', 'en_US'); // current date
      var date2 = formatDate(dateSent, 'yyyy-MM-dd', 'en_US'); // verbShowing date
      result = date1 >= date2 ? true : false;
    } else {
      result = true;
    }
    return result;
  }

  testTagName(searchValueForPost: string) {
    this.loaderService.disable = true;
    let tagName = '';
    if (searchValueForPost.indexOf('@') === 0) {
      tagName = searchValueForPost.slice(1);
    } else {
      tagName = searchValueForPost;
    }
    console.log('tagname:  ' + tagName);
    const params = new HttpParams().set('tagName', tagName); // getting profile Id from route.

    // APi call
    this.profileService.getProfileByTagName(params).subscribe((res) => {
      console.log(res);
      this.postOnOwnProfile = false;
      if (res.success === 0) {
        console.log('Here 1 : ' + res.success);
        this.profile = res.data; // All the responses retrieved.
        this.mentioned = true;
        if (this.user.defaultProfileId !== res.data.profileId) {
          console.log('Here 1 : ' + res.success);
          this.profile = res.data; // All the responses retrieved.
          this.mentioned = true;
        } else {
          //this.mentioned = false;
          this.postOnOwnProfile = true;
        }
      } else {
        console.log('Here 2 : ' + res.success);
        this.errMsg = 'Profile Not found.';
        this.mentioned = false;
        console.log(this.errMsg);
      }
    });
  }

  onChangeSearch(event: any) {
    this.loaderService.disable = true;
    //this.mentioned = false;
    if (event !== undefined && event !== null && event !== '') {
      if (event.indexOf('@') === 0) {
        event = event.slice(1);
      }
      const params = new HttpParams()
        .set('tagNameSubString', event)
        .set('limit', '20')
        .set('profileId', this.user.defaultProfileId.toString()); // getting profile Id from route.

      // API Call
      this.profileService.getSuggestions(params).subscribe((res) => {
        if (res.success === 0) {
          res.data.forEach((element: any) => {
            //this.mentioned = true;
            const tag = '@' + element.tagName;
            this.searchSuggetionListForPost.indexOf(tag) === -1
              ? this.searchSuggetionListForPost.push(tag)
              : '';
          });
        } else {
          //this.mentioned = false;
        }
      });
    }
    this.postOnOwnProfile = false;
    this.postOnblockProfile = false;
  }

  // Uploading images in the reviews.
  uploadReviewfile(event: any) {
    this.imageExceed = false;
    for (let val = 0; val < event.target.files.length; val++) {
      let file = event.target.files[val];
      let fullType = file.type;

      if (
        fullType == 'video/avi' &&
        fullType == 'image/jpeg' &&
        fullType == 'image/png'
      ) {
        this.mediaTypeInvalid = false;
      }

      let fileSize: number = file.size;
      if (fileSize > 26214400) {
        this.imageExceed = true;
        return;
      } else {
        this.imageExceed = false;
      }
      const extention = file.name.split('.').pop();
      let type = fullType.split('/')[0];
      if (fullType === 'audio/ogg') {
        type = 'video';
      }

      if (extention === 'mkv') {
        fullType = 'video/mp4';
      }

      var reader = new FileReader();
      reader.onload = (event: any) => {
        let contentHeader;

        if (file.type === 'image/jpeg') {
          contentHeader = 'image/jpeg';
        } else if (file.type === ' image/png') {
          contentHeader = 'image/png';
        } else {
          contentHeader = null;
        }

        if (contentHeader == null) {
          if (this.reviewImageCollectionUpload.length >= 7) {
            this.maxFiles = true;
            return;
          } else {
            this.reviewImageCollection.push([
              event.target.result,
              type,
              fullType,
            ]);
            this.reviewImageCollectionUpload.push(file);
          }
        } else {
          this.imgloading = true;
          this.loaderService.disable = true;
          this.apiService.checkContent(file, contentHeader).subscribe({
            next: (res) => {
              this.imgloading = false;
              console.log(res.IsImageAdultClassified);
              let isImageAdultClassified: boolean = res.IsImageAdultClassified;
              if (isImageAdultClassified == true) {
                this.contentInvalid = true;
              } else {
                this.contentInvalid = false;
                if (this.reviewImageCollectionUpload.length >= 7) {
                  this.maxFiles = true;
                  return;
                } else {
                  this.reviewImageCollection.push([
                    event.target.result,
                    type,
                    fullType,
                  ]);
                  this.reviewImageCollectionUpload.push(file);
                }
              }
            },
            error: () => {
              this.imgloading = false;
              this.contentInvalid = true;
              alert(
                'Image moderation could not be completed. Please try again.'
              );
            },
          });
        }
      };
      reader.readAsDataURL(file);
    }
    event.target.value = '';
  }

  checkContent(content: any) {
    console.log(content.length);
    if (content.length > 1000) {
      this.textContentLength = true; // Or set another flag for maxlength error
    } else {
      this.textContentLength = false;
    }
    if (content.trim().toString().length <= 0) {
      this.reviewContentValidation = false;
      return;
    } else {
      this.reviewContentValidation = true;
      this.checkTextContent(content);
    }
  }

  checkVlidation(categoryForm: NgForm) {
    this.loaderService.show();
    this.user = this.authService.getUser();

    if (this.review.content != null) {
      if (this.review.content.trim().toString().length == 0) {
        this.reviewContentValidation = false;
        this.loaderService.hide();
        return;
      }
    }

    if (this.review.subject == '' || this.review.subject == null) {
      this.loaderService.hide();
      return;
    }

    // if (this.mentioned == false) {
    //   console.log('Incorrect profile mentioned');
    //   return;
    // }
    if (categoryForm.invalid) {
      if (this.review.content == '') {
        this.reviewContentValidation = false;
      }
      this.loaderService.hide();
      return;
    }
    if (this.review.content.trim().toString().length == 0) {
      this.reviewContentValidation = false;
      this.loaderService.hide();
      return;
    }

    if (this.user.isPosted == false) {
      this.loaderService.hide();
      $('#postModal2').modal('show');
    } else {
      //this.disable = true;
      //this.postReview(categoryForm);
      this.checkTextContent([
        this.review.subject,
        this.review.content.trim().toString(),
      ]).then((isInvalid) => {
        if (isInvalid) {
          console.log('Text content invalid');
          this.loaderService.hide();
          return;
        } else {
          this.postReview(categoryForm);
        }
        // Do something with the result
      });
    }
  }

  checkPollFormValidation(categoryForm: NgForm) {
    if (!categoryForm.valid) {
      // Optionally show a message or focus on the first invalid field
      console.log('Form is invalid');
      return;
    }
    const fields: string[] = [
      this.review.pollDTO?.question || '',
      ...(this.review.pollDTO?.options || []).map((o) => o.optionText || ''),
    ];
    this.checkTextContent(fields).then((isInvalid) => {
      if (isInvalid) {
        console.log('Text content invalid');
        this.loaderService.hide();
        setTimeout(() => {
          const modalBody = document.querySelector(
            '#postReviewModel .modal-body'
          );
          if (modalBody) {
            modalBody.scrollTop = 0;
          }
        }, 50);
        return;
      }
      this.postReview(categoryForm);
    });
  }

  postReview(categoryForm: any) {
    console.log('postReview called, reviewType:', this.reviewType); // you'll see this is never logged
    this.postAReview(categoryForm);
    // if (searchValueForPost != '' || searchValueForPost != null) {
    //   this.loaderService.disable = true;
    //   let tagName = '';
    //   if (searchValueForPost.indexOf('@') === 0) {
    //     tagName = searchValueForPost.slice(1);
    //   }
    //   if (this.defaultProfile.tagName === tagName) {
    //     this.postOnOwnProfile = true;
    //     return;
    //   }
    //   if (this.blockAndBlockedByProfileList.includes(tagName)) {
    //     this.postOnblockProfile = true;
    //     return;
    //   }
    //   const params = new HttpParams().set('tagName', tagName); // getting profile Id from route.
    //   this.disable = true;
    //   // APi call
    //   this.profileService.getProfileByTagName(params).subscribe((res) => {
    //     this.mentioned = false;
    //     console.log(res);
    //     if (res.success === 0 && this.postOnOwnProfile === false) {
    //       console.log('Here 1 : ' + res.success);
    //       this.profile = res.data; // All the responses retrieved.
    //       this.mentioned = true;
    //       this.postAReview(categoryForm);
    //     } else {
    //       console.log('Here 2 : ' + res.success);
    //       this.errMsg = 'Profile Not found.';
    //       this.mentioned = false;
    //       this.disable = false;
    //       return;
    //     }
    //   });
    //  }
  }

  // for posting a review, will call the post a review API.
  postAReview(categoryForm: any) {
    console.log('called');
    this.disable = true;
    this.loaderService.disable = true;
    if (categoryForm.invalid) {
      console.log(
        'Form is invalid. Please correct the errors before submitting.'
      );
      this.disable = false;
      return;
    }
    if (this.reviewType === 'polling') {
      const question = this.review.pollDTO?.question;
      if (!question || question.length === 0) {
        this.disable = false;
        categoryForm.submitted = true; // trigger validation display
        return;
      }
    }

    var user = this.authService.getUser();
    this.review.byUserId = user['userId'];
    this.review.profileId = 0;
    this.review.byProfileId = user['defaultProfileId'];
    this.review.isReview = true;
    this.review.reviewId = null;
    this.review.reviewType = this.reviewType;
    let content: string | undefined;
    if (this.reviewType == 'chat') {
      delete this.review.pollDTO;
      content = this.review.content;
    } else if (this.review.pollDTO?.question !== null) {
      content = this.review.pollDTO?.question; // Assign question if it's not null.
    }
    if (this.user.city != null) {
      this.review.city = this.user.city;
    }
    if (this.user.state != null) {
      this.review.state = this.user.state;
    }
    if (this.user.country) {
      this.review.country = this.user.country;
    }
    // this.review.mentionProfileIds = this.profile.profileId.toString();

    if (content != undefined && content.includes('@')) {
      let mensionIds =
        this.review.mentionProfileIds + ',' + this.getAllMension(content);
      //this.review.mentionProfileIds = mensionIds;
      /*to make mentionProfileIds unique*/
      let mentionProfileIdList = mensionIds
        .split(',')
        .filter((item, i, ar) => ar.indexOf(item) === i);
      console.log('mentionProfileIdList=', mentionProfileIdList.toString());
      this.review.mentionProfileIds = mentionProfileIdList.toString();
    }

    const { insertResponse, ...result } = this.review;
    const formData: FormData = new FormData();
    formData.append('reviewDTO', JSON.stringify(result));
    var i;
    var mediaSize = 0;
    if (this.reviewImageCollectionUpload.length != 0) {
      for (i = 0; i < this.reviewImageCollectionUpload.length; i++) {
        formData.append('mediaFile', this.reviewImageCollectionUpload[i]);
        mediaSize = mediaSize + this.reviewImageCollectionUpload[i].size;
      }
    }
    if (this.textContentValid) {
      return;
    }

    // Validation used the global loader. The request itself owns this local
    // overlay so the user never sees two loaders for the same submission.
    this.loaderService.hide();
    this.loader = true;

    const handleSuccess = (res: any) => {
      const typeAtSuccess = this.reviewType;
      this.loader = false;
      if (res.success == 0) {
        //this.reviewCreated.emit({ ProfileID:  this.review.byProfileId });
        if (!this.user.isPosted) {
          this.user.isPosted = true;
          console.log(
            'User is posting first time, setting session data',
            this.user.isPosted
          );
          const sessionUser = this.authService.getUser();
          sessionUser.isPosted = true;
          this.authService.setSessionData(sessionUser);
        }
        $('#postModal2').modal('hide');
        $('#postReviewModel').modal('hide');
        $('#postReviewModel').one('hidden.bs.modal', () => {
          if (
            this.user.defaultProfileId == null &&
            this.user.reviewProfileId != null
          ) {
            this.reviewType = 'chat';
            $('#claimedReviewModal').modal('show');
          } else if (typeAtSuccess == 'polling') {
            $('#pollingSuccessModal').modal('show');
          } else {
            this.reviewType = 'chat';
            $('#successModal').modal('show');
          }
        });
        this.resetReviewModel(categoryForm, undefined, false, true);
      } else {
        $('#restrictModal').modal('show');
        $('#postModal2').modal('hide');
        $('#postReviewModel').modal('hide');
        $('#successModal').modal('hide');
        this.disable = false;
      }
    };

    const handleError = (error: any) => {
      this.loader = false;
      this.disable = false;
      console.error('Error while posting review:', error);
    };

    if (this.reviewType === 'polling' && this.review.id > 0 && this.isEditUrl) {
      this.isEditSuccess = true;
      const payload = {
        id: this.review.id,
        byUserId: this.review.byUserId,
        reviewType: this.reviewType,
        pollDTO: this.review.pollDTO,
        totalVotes: this.review.totalVotes || 0,
        mentionProfileIds: this.review.mentionProfileIds || '',
      };
      // Api call for editing poll
      this.profileService.editPoll(payload).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    } else if (
      this.reviewType === 'chat' &&
      this.review.id > 0 &&
      this.isEditUrl
    ) {
      this.isEditSuccess = true;
      const payload = {
        id: this.review.id,
        content: this.review.content,
        media: this.review.media || [],
        profileId: 0,
        byUserId: this.review.byUserId,
        byProfileId: this.review.byProfileId,
        isReview: true,
        reviewId: null,
        subject: this.review.subject,
        isConstituentsOnlyReply: this.review.isConstituentsOnlyReply,
        city: this.review.city,
        state: this.review.state,
        country: this.review.country,
        reviewType: 'chat',
        totalVotes: 0,
        likesCount: 0,
        mentionProfileIds: this.review.mentionProfileIds || '',
      };
      // Api call for editing conversation
      this.profileService.editConversation(payload).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    } else {
      this.isEditSuccess = false;
      // Api call for posting a review
      this.profileService.postAReview(formData).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    }

    var date1 = formatDate(new Date(), 'yyyy-MM-dd', 'en_US'); // current date
    var date2 = formatDate(this.user.verbShowingDate, 'yyyy-MM-dd', 'en_US'); // verbShowing date
    if (date1 >= date2) {
      this.setUserVerbDetail();
    }
  }

  setUserVerbDetail() {
    var user = this.authService.getUser();
    var verbeFrequency = user['verbeFrequency'];
    if (verbeFrequency == null) {
      verbeFrequency = 7;
    } else if (verbeFrequency == '7') {
      verbeFrequency = 15;
    } else if (verbeFrequency == '15') {
      verbeFrequency = 30;
    } else if (verbeFrequency == '30') {
      verbeFrequency = 30;
    }

    var someDate = new Date();
    someDate.setDate(someDate.getDate() + verbeFrequency); //number  of days to add, e.x. 15 days
    let nextdate = JSON.stringify(someDate);
    nextdate = nextdate.slice(1, 11);
    console.log('date:' + nextdate);
    this.review.byUserId = user['userId'];

    const params = new HttpParams()
      .set('userId', user['userId'])
      .set('verbShowingDate', nextdate)
      .set('verbFrequency', verbeFrequency);

    this.loaderService.disable = true;
    this.profileService.setVerbDetail(params).subscribe((res) => {
      var user = res.data;
      var sessionUser = this.authService.getUser();
      sessionUser.verbShowingDate = user.verbShowingDate;
      sessionUser.verbeFrequency = user.verbeFrequency;
      this.authService.setSessionData(sessionUser);
      this.designService.sendClickEvent();
    });
  }

  // get profile name suggestions when user starts typing.
  getSuggestions(event: any) {
    this.loaderService.disable = true;
    if (event !== undefined && event !== null && event !== '') {
      let promise: Promise<any>;
      promise = promise = new Promise((resolve, reject) => {
        let params = new HttpParams()
          .set('tagNameSubString', event)
          .set('limit', '20'); // getting profile Id from route.
        if (this.user && this.user.defaultProfileId) {
          params = params.set(
            'profileId',
            this.user.defaultProfileId.toString()
          );
        }

        // API Call
        this.profileService.getSuggestions(params).subscribe((res) => {
          const respData = res;
          if (respData.success == 0) {
            this.items = [];
            this.profileList = respData.data;
            for (let profile of this.profileList) {
              const temp: string = profile.profileImage;
              if (temp != null) {
                if (
                  temp.substring(temp.lastIndexOf('.') + 1, temp.length) ===
                    'jpeg' ||
                  temp.substring(temp.lastIndexOf('.') + 1, temp.length) ===
                    'png' ||
                  temp.substring(temp.lastIndexOf('.') + 1, temp.length) ===
                    'jpg'
                ) {
                } else {
                  profile.profileImage = '';
                }
              }
              this.items.push({
                id: `@${profile.tagName}`,
                text: `@${profile.tagName}`,
                name: profile.tagName,
                img: profile.profileImage,
              });

              this.allMensionList.push({
                id: profile.id,
                name: profile.tagName,
              });
            }
            resolve(this.items);
          } else {
            reject('No results found');
          }
        });
      });
      return promise;
    } else {
      // Return null or empty promise when the event is invalid
      return Promise.resolve([]);
    }
  }

  //to-do on delete review media
  deleteReviewMedia(index: any, element: any) {
    element.value = '';
    this.reviewImageCollectionUpload.splice(index, 1);
    this.thumbnailData.splice(index, 1);
    this.reviewImageCollection.splice(index, 1);
    if (this.reviewImageCollectionUpload.length <= 7) {
      this.maxFiles = false;
      return;
    }
  }

  onViewMoreReview(media: any, id: any) {
    this.viewMoreMedia = media;
    this.viewMoreMediaId = id;
    $('#postAReviewImgModal').modal('show');
  }

  // If mention selected then donot submit form
  itemSelected() {
    this.itemSelectedFleg = true;
  }

  ckeditor(element: any, onReady?: () => void) {
    const watchdog = new CKSource.Watchdog();
    const CKConfig = {
      toolbar: {
        items: ['bold', 'italic', 'underline'],
      },
      language: 'en',
      mention: {
        feeds: [
          {
            marker: '@',
            feed: (searchString: any) => {
              console.log(
                'PostReviewModelComponent -> ngOnInit -> searchString',
                searchString
              );
              this.username = searchString;
              return this.getSuggestions(searchString).then(() => {
                if (this.items.length !== 0) {
                  return this.items;
                } else {
                  return [{ name: searchString, notFound: true }];
                }
              });
            },
            minimumCharacters: 2,
            itemRenderer: customItemRenderer,
          },
        ],
      },
      removePlugins: ['Autoformat', 'ImageToolbar', 'MediaEmbedToolbar'], // Disable unused widget toolbars and autoformatting that may remove spaces
      typing: {
        transformations: {
          remove: [
            'nbsp', // Prevents CKEditor from removing non-breaking spaces
          ],
        },
      },
    };

    (window as any).watchdog = watchdog;

    watchdog.setCreator((element: any, config: any) => {
      return CKSource.Editor.create(element, config).then((editor: any) => {
        editor.editing.view.document.on('blur', () => {
          if (
            this.reviewType == 'polling' &&
            this.review.pollDTO != undefined
          ) {
            this.review.pollDTO.question = editor.getData();
            //this.checkContent(this.review.pollDTO.question);
          } else {
            this.review.content = editor.getData();
            // this.checkContent(this.review.content);
          }
        });
        const initialData =
          this.reviewType === 'polling'
            ? this.review.pollDTO?.question || ''
            : this.review.content || '';
        editor.setData(initialData);

        this.userToMention =
          this.userToMention || this.authService.getProfileName();
        if (this.userToMention && !initialData.trim()) {
          this.getSuggestions(this.userToMention);
          const viewFragment = editor.data.processor.toView(
            `<span class="mention" data-mention="@${this.userToMention}">@${this.userToMention}</span>&nbsp;`
          );
          const modelFragment = editor.data.toModel(viewFragment);

          editor.model.change((writer: any) => {
            const position = editor.model.document.selection.getFirstPosition();
            editor.model.insertContent(modelFragment, position);
          });
          this.authService.setProfileName('');
          this.userToMention = ''; // reset after inserting
        } else {
          this.authService.setProfileName('');
        }
        return editor;
      });
    });

    watchdog.setDestructor((editor: any) => {
      return editor.destroy();
    });

    watchdog.on('error', handleError);

    watchdog
      .create(element, CKConfig)
      .then(() => {
        if (onReady) onReady();
      })
      .catch(handleError);

    watchdog.on('restart', () => {
      watchdog.destroy();
      watchdog.create(element, CKConfig).catch(handleError);
    });

    function handleError(error: any) {
      console.error('Oops, something went wrong!');
      console.error(error);
    }

    function customItemRenderer(item: any) {
      console.log(
        'PostReviewModelComponent -> customItemRenderer -> item',
        item
      );
      const itemElement = document.createElement('button');
      if (item.notFound) {
        itemElement.className = 'row m-0 NotFound';
        itemElement.innerHTML = `
        <div class="col ck-mentions-name">${item.name}</div>`;
        // <div class="col-auto"><button type="button" class="btn-NotFound" data-mention="${item.name}" >Create Page</button></div>`;
      } else {
        itemElement.className = 'row m-0';
        const imgSrc = item.img ? item.img : '/assets/images/noprofile2.png';
        itemElement.innerHTML = `
            <div class="col-auto">
              <img src="${imgSrc}" class="ck-mentions-img">
            </div>
            <div class="col ck-mentions-name">${item.name}</div>`;
      }
      return itemElement;
    }

    $(document).on('click', '.btn-NotFound', (event: any) => {
      console.log(
        'PostReviewModelComponent -> notFoundCreatePage -> event',
        event
      );
      const element = event.target;
      const val = element.getAttribute('data-mention');
      console.log('PostReviewModelComponent -> ngOnInit -> val', val);
      this.username = val;
      $('#postReviewModel').addClass('slide-right');
      $('#postReviewToProfileModel').addClass('slide-right');
      $('#createProfileModal').modal('show');

      this.designService.showCreatePopup = true;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    });
  }

  closeCreatePageModal() {
    $('#postReviewModel').removeClass('slide-right');
    $('#postReviewToProfileModel').removeClass('slide-right');
    this.designService.showCreatePopup = false;
  }

  clear(event: any) {
    if (event.keyCode == 13) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  public get showCreatePopup(): boolean {
    return this.designService.showCreatePopup;
  }

  getAllMension(content: string) {
    var userTagsList: any[] = [];
    let mensionsList: string = ''; // all tags use in post content
    let tmp = content.replace(/[:<>=";/]/g, '');

    function extract([beg, end]: any) {
      const matcher = new RegExp(`${beg}(.*?)${end}`, 'gm');
      const normalise = (str: any) => str.slice(beg.length, end.length * -1);
      return function (str: any) {
        return str.match(matcher).map(normalise);
      };
    }
    const stringExtractor = extract(['@', '@']);
    userTagsList = stringExtractor(tmp);

    const result = Array.from(new Set(this.allMensionList.map((s) => s.id))) // distinct array
      .map((id) => {
        return {
          id: id,
          name: this.allMensionList.find((s) => s.id == id).name,
        };
      });
    console.log(result);
    result.forEach((element) => {
      // set user tags profile id in mensionsList
      if (userTagsList.includes(element.name)) {
        console.log(element.name);
        mensionsList += element.id + ',';
      }
    });

    if (mensionsList.substr(mensionsList.length - 1) === ',') {
      mensionsList = mensionsList.slice(0, -1);
    }
    return mensionsList;
  }

  checkTextContent(content: string | string[]): Promise<boolean> {
    this.textContentValid = false;
    const cleaned: string | string[] = Array.isArray(content)
      ? content
          .map((c) => (c || '').replace(/<[^>]*>/g, '').replace('&nbsp;', ''))
          .filter((c) => c.trim().length > 0)
      : content.replace(/<[^>]*>/g, '').replace('&nbsp;', '');
    console.log('content :', cleaned);
    this.loaderService.disable = true;

    return new Promise<boolean>((resolve, reject) => {
      this.apiService.checkTextContent(cleaned).subscribe(
        (res) => {
          console.log('res: ', JSON.stringify(res));
          if (res && res.IsTextFlagged) {
            this.textContentValid = true;
            resolve(true);
          } else {
            this.textContentValid = false;
            resolve(false);
          }
        },
        (error) => {
          console.error('Error: ', error);
          this.textContentValid = true;
          resolve(true);
        }
      );
    });
  }

  reloadPage() {
    window.location.reload();
  }

  closePopup(
    form?: NgForm,
    pollForm?: NgForm,
    preserveEditSuccess: boolean = false
  ) {
    this.resetReviewModel(form, pollForm, false, preserveEditSuccess);
    this.pollEditorInitialized = false;
    this.ckeditorInitialized = false;
    this.isModalOpening = false;
    this.editorLoading = false;
    this.isEditUrl = false;
    $('#postReviewModel').modal('hide');
    const url = new URL(window.location.href);
    url.searchParams.delete('edit');
    this.location.replaceState(url.pathname + url.search);
    setTimeout(() => {
      const modal = document.querySelector('#postReviewModel');
      // Remove editor DOM elements to ensure proper cleanup
      if (modal) {
        modal.querySelectorAll('.ck-editor').forEach((element) => {
          console.log('gone' + element);
          element.remove();
        });
      }
      //this.ckeditor(document.querySelector('#content'));
    }, 300);
  }

  resetReviewModel(
    form?: NgForm,
    pollForm?: NgForm,
    preserveType: boolean = false,
    preserveEditSuccess: boolean = false
  ) {
    if (form) {
      form.resetForm();
    }
    if (pollForm) {
      pollForm.resetForm();
    }
    this.mentioned = false;
    this.postOnblockProfile = false;
    this.postOnOwnProfile = false;
    this.contentInvalid = false;
    this.textContentValid = false;
    if (!preserveEditSuccess) {
      this.isEditSuccess = false;
    }
    this.review = new Review();
    this.review.content = '';
    this.review.subject = '';
    this.review.pollDTO = new PollDTO();
    this.review.pollDTO.pollDurationInDays = this.daysArray[0];
    if (!preserveType) {
      this.reviewType = 'chat';
    }
    this.isEditUrl = false;
  }
  selectEvent(value: any) {
    this.searchValueForPost = value;
    this.testTagName(value);
    this.onChangeSearch(value);
  }
  getBlockProfileDetails() {
    const params = new HttpParams().set(
      'profileId',
      this.user.defaultProfileId.toString()
    );
    this.profileService.getBlockProfiles(params).subscribe((res) => {
      const blockProfileList = res.data.blockedProfileList;
      const blockedByProfileList = res.data.blockedByProfileList;
      for (const profile of blockedByProfileList) {
        this.blockAndBlockedByProfileList.push(profile.tagName);
      }
      for (const profile of blockProfileList) {
        this.blockAndBlockedByProfileList.push(profile.tagName);
      }
    });
  }

  // Purpose : For updating user
  updateUser() {
    this.userService.editUser(this.user).subscribe((res) => {
      this.authService.setSessionData(this.user);
      if (res.success != 0) {
        console.log('Error while updating user');
      }
    });
  }

  closeModal() {
    $('#postReviewModel').modal('hide');
    this.closePopup();
    $('#postReviewModel').on('hidden.bs.modal', () => {
      document.body.classList.remove('modal-open');
    });
  }
  sendBugReportOrFeedback(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.reportBugFeedbackDTO.userId = this.user.userId;

    this.userService
      .sendBugReportOrFeedback(this.reportBugFeedbackDTO)
      .subscribe((res: any) => {
        const respData = res;
        if (respData.success == 0) {
          $('#haveFeedback').modal('hide');
          this.resetFormData(form);
        } else {
          $('#haveFeedback').modal('hide');
          this.resetFormData(form);
          console.log('Error while sending report bug or feedback');
        }
      });
  }

  resetFormData(form: NgForm) {
    form.resetForm();
    this.reportBugFeedbackDTO = new ReportBugFeedbackDTO();
  }
  openModal() {
    $('#conversionTabModal').modal('hide');
    // this.isEditUrl = window.location.href.includes('edit=true');
    if (!this.isEditUrl) {
      this.isEditUrl = window.location.href.includes('edit=true');
    }
    // If we're opening for a new post/poll (from conversionTabModal),
    // and we DON'T have a pending edit (isFromReminder is specifically for community guidelines path),
    // ensure the state is clean.
    if (!this.isFromReminder && this.review.id == 0) {
      this.resetReviewModel(undefined, undefined, true);
    }

    // Remember profile tag for mention insertion, but don’t assign raw text.
    const profileName = this.authService.getProfileName();
    if (profileName && this.review.id == 0) {
      this.userToMention = profileName;
    }

    if (this.reviewType == 'polling') {
      $('#postReviewModel').modal('show');
      // this.ckeditor(document.querySelector('#question'));
      $('#postReviewModel')
        .off('shown.bs.modal')
        .on('shown.bs.modal', () => {
          document.body.classList.add('modal-open');
          setTimeout(() => {
            if (this.review.pollDTO) {
              const val = Number(this.review.pollDTO.pollDurationInDays);
              this.review.pollDTO.pollDurationInDays = 0; // force change detection
              this.cdr.detectChanges();
              this.review.pollDTO.pollDurationInDays = val; // set correct value
              this.cdr.detectChanges();
            }
          }, 200);
          const el = document.querySelector('#question');
          if (el && !this.pollEditorInitialized) {
            this.ckeditor(el);
            this.pollEditorInitialized = true;
          }

          // If editing, set initial value
          if (this.review.pollDTO && this.review.pollDTO.question) {
            // ... logic from before ...
          }

          // ✅ reset opening flag AFTER modal fully opens
          this.isModalOpening = false;
        });
    } else if (this.reviewType == 'announcement') {
      $('#postReviewModel').modal('hide');
      this.router.navigateByUrl('profile/create-announcement');
    } else {
      this.editorLoading = true;
      $('#postReviewModel').modal('show');
      $('#postReviewModel')
        .off('shown.bs.modal')
        .on('shown.bs.modal', () => {
          document.body.classList.add('modal-open');
          const el = document.querySelector('#content');
          if (el && !this.ckeditorInitialized) {
            this.ckeditor(el, () => {
              this.editorLoading = false;
            });
            this.ckeditorInitialized = true;
          } else {
            this.editorLoading = false;
          }
          this.isModalOpening = false;
        });
    }
  }

  // Purpose : To add option
  addOption() {
    if (this.review.pollDTO != undefined) {
      this.review.pollDTO.options.push({
        optionId: 0,
        optionText: '',
        votes: 0,
        isVoted: false,
      });
    }
  }

  // Purpose : To delete option
  deleteOption(index: number) {
    if (this.review.pollDTO != undefined) {
      this.review.pollDTO.options.splice(index, 1);
    }
  }
  openCommunityModal(event: any) {
    event.preventDefault();

    this.isFromReminder = true;
    $('#postReviewModel').modal('hide');
    $('#postModal2').modal('show');
  }
  onOkClick() {
    this.isFromReminder = false;
    $('#postModal2').modal('hide');
    $('#postReviewModel').modal('show');
  }
  communityclose() {
    this.isFromReminder = false;
    $('#postModal2').modal('hide');
    $('#postReviewModel').modal('show');
  }
}
